import React from "react";
import PropTypes from "prop-types";
import Shimmer from "@techsoftware/happay-widgets/Shimmer";

// import "./style.scss";

// function Pagination() {
//     return (
//         <div className={"pagination-grid"}>
//             <div className={"grid"}>
//                 <div
//                     className={"grid-shimmer"}
//                     style={{ width: "170px", height: "26px", marginLeft: "1rem" }}
//                 />
//             </div>
//             <div className={"grid"}>
//                 <div className={"grid-shimmer"} style={{ width: "170px", height: "26px" }} />
//             </div>
//         </div>
//     );
// }
// function TableHeader(props) {
//     const col = [];
//     for (let i = 0; i < props.noOfCol; i++) {
//         col.push(
//             <div className={"grid border-right"} key={`${i}-col`}>
//                 <div className={"grid-shimmer"} style={{ width: "70%" }}></div>
//             </div>
//         );
//     }
//     return <div className="table-shimmer-header container">{col}</div>;
// }
// function TableRow(props) {
//     const col = [];
//     for (let i = 0; i < props.noOfCol; i++) {
//         col.push(
//             <div className={"grid"} key={`${i}-row`}>
//                 <div className={"grid-shimmer"} style={{ width: "50%" }}></div>
//             </div>
//         );
//     }
//     return <div className="table-shimmer-header container">{col}</div>;
// }
// const TableShimmer = props => {
//     const { noOfCol, noOfRow, hidePagination, hideHeader } = props;
//     const row = [];
//     for (let i = 0; i < noOfRow; i++) {
//         row.push(<TableRow key={`${i}-noOfCol`} noOfCol={noOfCol} />);
//     }
//     return (
//         <div className="table-shimmer-container">
//             {!hidePagination && <Pagination />}
//             {!hideHeader && <TableHeader noOfCol={noOfCol} />}
//             {row}
//         </div>
//     );
// };

const TableShimmer = props => {
    const { noOfRow, noOfCol, className, ...rest } = props;
    return <Shimmer type="table" row={noOfRow} column={noOfCol} className={className} />;
};

TableShimmer.propTypes = {
    TableRow: PropTypes.bool
};
TableShimmer.defaultProps = {
    noOfRow: 8,
    noOfCol: 4
};

export default TableShimmer;
